<template>
  <!-- If user is in test, show these: -->
  <div class="borrowerAttributeSsn">
    <div>
      <BorrowerAttributeConstructor
        :questionText="questionText"
        :description="description"
        :descriptionTooltip="descriptionTooltip"
        :disclaimer="disclaimer">
        <template v-slot:input>
          <div class="form-floating">
            <input :id="'ba' + identifier" :name="'ba' + identifier" class="form-control"
              inputmode="numeric"
              type="password"
              :class="{
                'is-invalid': v$.value &&  v$.value.$invalid && v$.value.$dirty,
                'disabled': disabled,
                'disabled-repressed': disabled && repressDisabledStyle,
              }"
              v-model="value"
              :disabled="disabled"
              :required="question.required"
              :placeholder="label"
              :maxlength="9"
              :minlength="9"
              @change="onChange(v$.value)"
              @blur="onBlur(v$.value, $event)"
              :data-cy="question.alias"
            />
            <label class="type-400" :for="'ba-' + identifier">
              <span>{{ label }}</span>
            </label>
            <small v-if="v$.value && !v$.value.$error && question.helpText && (!isDNQ || ignoreDNQChecks) && !hideHelpText" class="help-text">
              <fa-icon :icon="['far', 'circle-info']"></fa-icon>
              {{ question.helpText }}
            </small>
            <span class="invalid-feedback" v-if="v$.value && v$.value.$error && v$.value.$dirty">
              <fa-icon :icon="['fal', 'circle-exclamation']"></fa-icon> {{ errorText }}
            </span>
          </div>
        </template>
      </BorrowerAttributeConstructor>
  </div>
  </div>
</template>

<script>
  import { useVuelidate } from '@vuelidate/core'
  import { required, minLength, maxLength } from '@vuelidate/validators'
  import get from 'lodash/get'
  import BaseBorrowerAttributeMixin from './BaseBorrowerAttributeMixin'
  import { mapState } from 'pinia'
  import { useExperienceStore } from '~/store/experience'

  export default {
    props: {
      disabled: Boolean,
      repressDisabledStyle: Boolean,
      fourDigitSSN: Boolean,
      hideHelpText: Boolean,
      ignoreDNQChecks: Boolean
    },
    emits: ['invalidity','answer'],
    setup: () => ({ v$: useVuelidate() }),
    data () {
      return {
        errorMessage: 'Please enter a 9 digit social security number',
        altErrorMessage: 'Please enter the last 4 digits of your social security number',
        altLabel: 'Last 4 digits of Social Security Number',
      }
    },
    mounted () {
      this.$watch('invalid', (invalid) => {
        this.$emit('invalidity', invalid)
      }, {immediate: true})
    },
    computed: {
      ...mapState(useExperienceStore, ['isDNQ']),
      invalid() {
        return this.v$.$invalid
      },
      errorText() {
        return get(this.v$, 'value.$error') ? this.errorMessage : ''
      },
    },
    methods: {
      onBlur (v$, e) {
        v$.$touch()
        this.$emit('answer', { value: e.target.value, isInvalid: v$.$error })
      },
      onChange (v$) {
        this.value && this.value.length === 9 && v$.$touch()
      },
    },
    mixins: [BaseBorrowerAttributeMixin],
    validations: function () {
      return {
        value: {
          required,
          minLength: minLength(9),
          maxLength: maxLength(9),
          pattern: (val) => {
            return /\*{5}\d{4}/.test(val) && val == this.question.value || /\d{9}/.test(val)
          }
        },
      }
    }
  }
</script>
